import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Alert } from "@mui/material";
import { trackEvents } from "../api/analytics";

function MenuIpCopySnackbar() {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText("mcverse.city");
    setOpen(true);
    trackEvents([
      { eventType: "copy_ip", metadata: { source: "menu" } },
    ]);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        action={action}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Copied IP to clipboard
        </Alert>
      </Snackbar>

      <Tooltip title="Click to Copy IP">
        <Box sx={{ display: "flex", alignItems: "center", mr: 1.5 }}>
          <Button
            variant="outlined"
            onClick={handleClick}
            aria-label="Copy server IP"
            sx={{
              display: { xs: "inline-flex", md: "none" },
              minWidth: 0,
              px: 1,
              py: 0.25,
              color: "#fff",
              borderColor: "#fff",
              fontFamily: "monospace",
              fontWeight: 700,
              fontSize: "0.75rem",
              lineHeight: 1.2,
              "&:hover": {
                borderColor: "#fff",
                bgcolor: "rgba(255, 255, 255, 0.08)",
              },
            }}
          >
            IP
          </Button>
          <Typography
            variant="button"
            component="button"
            type="button"
            onClick={handleClick}
            noWrap
            sx={{
              display: { xs: "none", md: "inline-flex" },
              p: 0,
              border: 0,
              bgcolor: "transparent",
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".05rem",
              color: "#fff",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            IP: MCVERSE.CITY
          </Typography>
        </Box>
      </Tooltip>
    </div>
  );
}
export default MenuIpCopySnackbar;
